import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminProjectsInProgressInformationItems = async (params) => {
    const response = await axiosInstance.get(
        API_ENDPOINTS.ADMIN.PROJECTS_IN_PROGRESS_INFORMATION_ITEMS.GET_ALL,
        { params },
    );
    return response.data;
};

export const getAdminProjectInProgressInformationItemById = async (id) => {
    const response = await axiosInstance.get(
        API_ENDPOINTS.ADMIN.PROJECTS_IN_PROGRESS_INFORMATION_ITEMS.GET_BY_ID(id),
    );
    return response.data;
};

export const createProjectsInProgressInformationItemsBatch = async (data) => {
    const response = await axiosInstance.post(
        API_ENDPOINTS.ADMIN.PROJECTS_IN_PROGRESS_INFORMATION_ITEMS.CREATE_BATCH,
        data,
    );
    return response.data;
};

export const updateProjectInProgressInformationItem = async (id, data) => {
    const response = await axiosInstance.put(
        API_ENDPOINTS.ADMIN.PROJECTS_IN_PROGRESS_INFORMATION_ITEMS.UPDATE(id),
        data,
    );
    return response.data;
};

export const deleteProjectInProgressInformationItem = async (id) => {
    const response = await axiosInstance.delete(
        API_ENDPOINTS.ADMIN.PROJECTS_IN_PROGRESS_INFORMATION_ITEMS.DELETE(id),
    );
    return response.data;
};
